import Button from "components/Button";
import { createContext, useContext, useState } from "react";
import styled from "styled-components";
import { colors } from "styles";

const Context = createContext();

export const useConfirm = () => useContext(Context);

export const ConfirmProvider = ({ children }) => {
  const [state, setState] = useState(null);

  const open = (body, onConfirm) => {
    setState({ title: "¡Atención!", body, onConfirm });
  };

  const close = () => {
    setState(null);
  };

  return (
    <Context.Provider value={{ open, close }}>
      {children}

      {state && (
        <Root>
          <Content>
            <Icon>!</Icon>

            <Title>{state.title}</Title>

            <Body>{state.body}</Body>

            <Actions>
              <Button
                $fluid
                onClick={() => {
                  state.onConfirm();
                  close();
                }}
              >
                Continuar
              </Button>
              <Button
                $fluid
                $type="secondary"
                onClick={() => {
                  close();
                }}
              >
                Cancelar
              </Button>
            </Actions>
          </Content>
        </Root>
      )}
    </Context.Provider>
  );
};

export default ConfirmProvider;

const Root = styled.div`
  z-index: 999;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const Content = styled.div`
  width: 100%;
  max-width: 500px;
  background: white;
  padding: 15px;
  font-size: 1.2em;
  box-shadow: 0px 0px 20px 0 rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  overflow: hidden;
  text-align: center;

  &:before {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 50px;
    top: 0;
    left: 0;
    background: ${colors.blue};
  }
`;

const Icon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${colors.yellow};
  color: ${colors.white};
  width: 70px;
  height: 70px;
  border-radius: 70px;
  font-size: 2.6em;
  padding-top: 7px;
  padding-right: 1px;
  border: 7px solid ${colors.white};
`;

const Title = styled.div`
  font-size: 1.5em;
  font-weight: bold;
`;

const Body = styled.div`
  padding: 20px 0 40px;
`;

const Actions = styled.div`
  display: grid;
  gap: 10px;

  @media screen and (min-width: 400px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
